

































































































































































































import { defineComponent } from "@vue/composition-api";

import {
  formKeyLabelList,
  formPlaceholderList,
  formDescriptionList,
  EditingOfficialContent
} from "@/helpers/official";
import { OFFICIAL_STORE_KEY } from "@/helpers/hooks/useOfficial";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";

import InputFieldGroup from "@/components/Organisms/InputFieldGroup/index.vue";
import InputField from "@/components/Organisms/InputField/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import FieldAddButton from "@/components/Atoms/Forms/FieldAddButton/index.vue";
import ImageCropper from "@/components/Organisms/ImageCropper/index.vue";
import EmptyView from "@/components/Atoms/EmptyView/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";

export default defineComponent({
  components: {
    InputFieldGroup,
    InputField,
    TextField,
    TextArea,
    FieldAddButton,
    ImageCropper,
    EmptyView,
    OccHeading
  },
  name: "ImageForm",
  setup() {
    const {
      isPendingVersion,
      officialEditingForm,
      onSetForm,
      setUncroppedContentImage,
      resetOfficialContentImage,
      getOfficialErrorMessage,
      getOfficialWarnMessage,
      addOfficialContent,
      deleteOfficialContent,
      changeOrderOfficialContents,
      resetOfficialError
    } = useGlobalState(OFFICIAL_STORE_KEY);

    const onSetUncroppedContentImage = (
      image: EditingOfficialContent,
      value: string
    ) => {
      // 既存の画像＆エラーは削除
      resetOfficialContentImage({
        mainKey: "images",
        id: (image.id || image.tmpId) as number,
        subKey: "image1"
      });
      resetOfficialError({
        mainKey: "images",
        id: image.id || image.tmpId,
        subKey: "image1"
      });

      setUncroppedContentImage(
        {
          mainKey: "images",
          id: image.id || image.tmpId
        },
        value
      );
    };

    const defaultImage = (image: EditingOfficialContent) => {
      if (image.image1) {
        return image.image1;
      } else if (image.uncroppedImage) {
        return image.uncroppedImage;
      } else {
        return "";
      }
    };

    return {
      // official.tsのヘルパー関連
      formKeyLabelList,
      formPlaceholderList,
      formDescriptionList,

      // ストア関連
      isPendingVersion,
      officialEditingForm,
      onSetForm,
      setUncroppedContentImage,
      getOfficialErrorMessage,
      getOfficialWarnMessage,
      addOfficialContent,
      deleteOfficialContent,
      changeOrderOfficialContents,

      // コンポーネント内定義
      onSetUncroppedContentImage,
      defaultImage
    };
  }
});
